export default function TestimonialSection() {
  return (
    <section className="py-32 px-6 lg:px-60 bg-gradient-to-br from-blue-50 to-purple-50">
      <div className="max-w-5xl mx-auto bg-white/80 backdrop-blur-sm border border-gray-200 rounded-2xl p-10 lg:p-16 flex flex-col items-center gap-8 shadow-xl">

        {/* Quote Icon */}
        <svg
          className="w-16 h-16 text-sky-300"
          viewBox="0 0 64 64"
          fill="none"
        >
          <path
            d="M42.66 8C39.72 8 37.33 10.39 37.33 13.33V29.33C37.33 32.27 39.72 34.66 42.66 34.66C44.13 34.66 45.33 35.86 45.33 37.33V40C45.33 42.94 42.94 45.33 40 45.33C38.52 45.33 37.33 46.52 37.33 48V53.33C37.33 54.8 38.52 56 40 56C48.83 56 56 48.83 56 40V13.33C56 10.39 53.6 8 50.66 8H42.66"
            stroke="currentColor"
            strokeWidth="5.3"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M13.33 8C10.39 8 8 10.39 8 13.33V29.33C8 32.27 10.39 34.66 13.33 34.66C14.8 34.66 16 35.86 16 37.33V40C16 42.94 13.61 45.33 10.66 45.33C9.19 45.33 8 46.52 8 48V53.33C8 54.8 9.19 56 10.66 56C19.49 56 26.66 48.83 26.66 40V13.33C26.66 10.39 24.27 8 21.33 8H13.33"
            stroke="currentColor"
            strokeWidth="5.3"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>

        {/* Quote Text */}
        <p className="text-center text-2xl lg:text-3xl font-medium text-gray-900 leading-relaxed max-w-3xl">
          “Revinu helped us recover payments we were previously writing off.
          It runs silently in the background while our team focuses on growth.”
        </p>

        {/* Author */}
        <div className="flex items-center gap-4 pt-2">

          {/* Avatar */}
          <div className="w-14 h-14 rounded-full bg-gradient-to-br from-sky-500 to-purple-500"></div>

          {/* Details */}
          <div>
            <p className="font-bold text-gray-900">
              Head of Finance
            </p>
            <p className="text-sm text-sky-600 font-medium">
              Enterprise SaaS Platform
            </p>
          </div>

        </div>

      </div>
    </section>
  );
}